<template>
    <div>
        <loader v-if="isLoading" />
        <div v-else>
            <div v-if="url">
                <g-typography tag="h4" class="g-mt-5" font-weight="semibold" value="Business Details" />
                <g-typography tag="p" class="g-mt-3">
                    <g-link tag="a" type="normal" :href="url" target="_blank">{{ url }}</g-link>
                </g-typography>
            </div>

            <g-typography
                v-if="representative"
                tag="h4"
                class="g-mt-5"
                font-weight="semibold"
                value="Account Representative"
            />
            <g-typography tag="p" class="g-mt-3" :value="representative" />

            <g-typography
                v-if="email || phone"
                tag="h4"
                class="g-mt-5"
                font-weight="semibold"
                value="Account Contact"
            />
            <g-typography tag="p" class="g-mt-3">
                <g-link tag="a" type="normal" :href="`mailto:${email}`">{{ email }}</g-link
                ><span v-if="email && phone">, </span>
                {{ phone }}
            </g-typography>

            <g-typography v-if="address" tag="h4" class="g-mt-5" font-weight="semibold" value="Account Address" />
            <g-typography tag="p" class="g-mt-3" :value="address" />

            <g-button
                class="g-mt-5"
                shape="round"
                size="large"
                theme="live"
                :type="onboardingButtonType"
                :loading="isLinkLoading"
                :disabled="isLinkLoading"
                @click="handleOnboarding()"
            >
                {{ onboardingButtonLabel }}
            </g-button>
        </div>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import { STRIPE_CONNECT_BUSINESS_TYPE_INDIVIDUAL } from '../../../../../app-v2/constants/payouts';
    import { formatUsPhoneNumber } from '../../../../../app-v2/helpers/formatters';

    export default {
        name: 'TaxInformation',

        props: {
            isLoading: {
                type: Boolean,
                default: false
            },
            isLinkLoading: {
                type: Boolean,
                default: false
            },
            payoutAccount: {
                type: Object,
                default: null
            },
            onboardingButtonLabel: {
                type: String,
                default: ''
            },
            onboardingButtonType: {
                type: String,
                default: ''
            }
        },

        setup(props, context) {
            const url = computed(() => {
                return props.payoutAccount?.external_account?.business_url;
            });

            const representative = computed(() => {
                return props.payoutAccount?.external_account?.business_type === STRIPE_CONNECT_BUSINESS_TYPE_INDIVIDUAL
                    ? ''
                    : props.payoutAccount?.external_account?.business_name;
            });

            const email = computed(() => {
                return props.payoutAccount?.external_account?.business_type === STRIPE_CONNECT_BUSINESS_TYPE_INDIVIDUAL
                    ? props.payoutAccount?.external_account?.contact_email
                    : '';
            });

            const phone = computed(() => {
                return formatUsPhoneNumber(props.payoutAccount?.external_account?.contact_phone);
            });

            const address = computed(() => {
                if (!props.payoutAccount?.external_account?.address_line1) {
                    return '';
                }

                let formatted = `${props.payoutAccount?.external_account?.address_line1}, `;

                if (props.payoutAccount?.external_account?.address_line2) {
                    formatted += `${props.payoutAccount?.external_account?.address_line2}, `;
                }

                if (props.payoutAccount?.external_account?.address_city) {
                    formatted += `${props.payoutAccount?.external_account?.address_city}, `;
                }

                if (props.payoutAccount?.external_account?.address_state) {
                    formatted += props.payoutAccount?.external_account?.address_state;
                }

                if (props.payoutAccount?.external_account?.address_zip) {
                    formatted += ` ${props.payoutAccount?.external_account?.address_zip}`;
                }

                return formatted;
            });

            const handleOnboarding = async () => {
                context.emit('redirect-to-stripe-connect');
            };

            return {
                url,
                representative,
                email,
                phone,
                address,

                handleOnboarding
            };
        }
    };
</script>
